import { Widget } from './WidgetInterface'
import { WidgetType } from './WidgetTypes'

import { WidgetActivity } from '../../activity/Activity.widget'
import { WidgetAlarmInformations } from '../../alarm-informations/AlarmInformations.widget'
import { WidgetWidgetContainer } from '../../container/WidgetContainer.widget'
import { WidgetCountdown } from '../../countdown/Countdown.widget'
import { WidgetCrewtarget } from '../../crewtarget/Crewtarget.widget'
import { WidgetDirectMessages } from '../../direct-messages/DirectMessages.widget'
import { WidgetDragDropIndicator } from '../../drag-drop-indicator/DragDropIndicator.widget'
import { WidgetHeader } from '../../header/Header.widget'
import { WidgetIframe } from '../../iframe/Iframe.widget'
import { WidgetMap } from '../../map/Map.widget'
import { WidgetMessages } from '../../messages-widget/Messages.widget'
import { WidgetMessenger } from '../../messenger/Messenger.widget'
import { WidgetReport } from '../../report/Report.widget'
import { WidgetSpacer } from '../../spacer/Spacer.widget'
import { WidgetStatusCompact } from '../../status-compact/StatusCompact.widget'
import { WidgetStatusDetail } from '../../status-detail/StatusDetail.widget'
import { WidgetVehicleStatusHistory } from '../../vehicle-status-history/VehicleStatusHistory.widget'
import { WidgetVehicleStatus } from '../../vehicle-status/VehicleStatus.widget'

export type WidgetSpecifications = { [type: string]: Widget }

export class WidgetService {
  static widgets: WidgetSpecifications = {
    [WidgetType.activity]: WidgetActivity,
    [WidgetType.alarmInformations]: WidgetAlarmInformations,
    [WidgetType.countdown]: WidgetCountdown,
    [WidgetType.crewtarget]: WidgetCrewtarget,
    [WidgetType.directMessages]: WidgetDirectMessages,
    [WidgetType.dragDropIndicator]: WidgetDragDropIndicator,
    [WidgetType.header]: WidgetHeader,
    [WidgetType.iframe]: WidgetIframe,
    [WidgetType.map]: WidgetMap,
    [WidgetType.messages]: WidgetMessages,
    [WidgetType.messenger]: WidgetMessenger,
    [WidgetType.report]: WidgetReport,
    [WidgetType.spacer]: WidgetSpacer,
    [WidgetType.statusCompact]: WidgetStatusCompact,
    [WidgetType.statusDetail]: WidgetStatusDetail,
    [WidgetType.vehicleStatus]: WidgetVehicleStatus,
    [WidgetType.vehicleStatusHistory]: WidgetVehicleStatusHistory,
    [WidgetType.widgetContainer]: WidgetWidgetContainer
  }

  public static getWidgetSpecifications(): WidgetSpecifications {
    return this.widgets
  }

  public static getWidgetSpecification(widgetType: WidgetType): Widget {
    return this.widgets[widgetType]
  }
}
